import ContractHistory from './ContractHistory.vue';

export default ContractHistory;
